<template>
  <div style="height: 100%">
    <section class="h-100 d-flex">
      <div class="container my-md-auto manutencao_cont">
        <div class="row d-flex justify-content-between align-items-center text-center">
          <div class="col-md-6 mt-4 mt-md-0">
            <h1>Site em<br>manutenção</h1>
            <p>Em breve estaremos de volta com nosso site melhorado.</p>
          </div>
          <div class="col-md-6 mt-4 mt-md-0">
            <img src="/static/images/manutencao.svg">
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
  export default {
    name: "Manutencao"
  }
</script>



// WEBPACK FOOTER //
// src/components/Manutencao.vue